/* istanbul ignore file */

/* eslint-disable camelcase */

// File ignored for testing; These methods should all be pass-thru calls to auto-generated code;

import {
  EventsService,
  SchedulerService,
  UsersService,
} from 'api-clients/monolith';
import { useCallback } from 'react';

import { Filterable } from 'components/FilterDropdown/util';

import { useApiService } from '../../hooks/useApiService';

export const useGetContext = () => {
  const fetch = useCallback(
    () => SchedulerService.getInternalApiSchedulerCronofyInformation(),
    [],
  );

  return useApiService(fetch);
};

export const useUsersOptions = () => {
  const fetch = useCallback(
    () => UsersService.getInternalApiUsersPackUserOptions(),
    [],
  );

  return useApiService(fetch);
};

export type EventUserOption = Awaited<
  ReturnType<typeof UsersService.getInternalApiUsersPackUserOptions>
>[0];

export type EventLocationOption = Awaited<
  ReturnType<typeof EventsService.getInternalApiEventsConditions>
>;

export const useEventStageOptions = ({
  stages,
  funnels,
}: {
  stages: Filterable[];
  funnels: Filterable[];
}) => {
  const fetch = useCallback(
    () =>
      EventsService.getInternalApiEventsStageOptions(
        stages.map(f => f.id),
        funnels.map(f => f.id),
      ),
    [stages, funnels],
  );

  return useApiService(fetch);
};

export type EventStageOption = Awaited<
  ReturnType<typeof EventsService.getInternalApiEventsStageOptions>
>[0];

export const useNewEventAvailability = ({
  applicantId,
  stageId,
}: {
  applicantId: string;
  stageId: string;
}) => {
  const fetch = useCallback(
    () =>
      EventsService.getInternalApiEventsAvailabilityNew(applicantId, stageId),
    [applicantId, stageId],
  );

  return useApiService(fetch);
};

export type NewEventAvailability = Awaited<
  ReturnType<typeof EventsService.getInternalApiEventsAvailabilityNew>
>;

export const useEventsBookings = ({ seriesKey }: { seriesKey: string }) => {
  const fetch = useCallback(
    () => EventsService.getInternalApiEventsBookings(seriesKey),
    [seriesKey],
  );

  return useApiService(fetch);
};
